import { Route } from 'react-router';
import { InvoiceVaultPage } from '../InvoiceVaultPage';
import { getInvoiceVaultPath } from '../path/path';

export const InvoiceVaultRoutes = [
  <Route key={getInvoiceVaultPath()} path={getInvoiceVaultPath()} element={<InvoiceVaultPage />} />,
];
